import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PerfilComponent } from './perfil.component';

const routes: Routes = [
  { path: '', component: PerfilComponent },
  {
    path: 'trocar-foto',
    loadChildren: () => import('./trocar-foto/trocar-foto.module').then(m => m.TrocarFotoModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PerfilRoutingModule { }
